<div class="p-6">
  <h2 class="text-2xl font-semibold text-gray-900 mb-6">Edit Fence</h2>
  
  <form [formGroup]="editFenceForm" class="space-y-4">
    <div class="space-y-4">
      <!-- Name Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Name</label>
        <input 
          formControlName="name" 
          type="text" 
          placeholder="Enter fence name"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 placeholder:text-gray-400 placeholder:italic"
        >
      </div>

      <!-- Length Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Length (m)</label>
        <input 
          type="number" 
          readonly 
          [value]="data.fence.length"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-500 cursor-not-allowed"
        >
      </div>

      <!-- Assigned Paddocks -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Assigned paddocks</label>
        <select 
          formControlName="paddocks" 
          multiple
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option *ngFor="let paddock of paddockService.paddocks | async" [value]="paddock.paddockID">
            {{ paddock.name }}
          </option>
        </select>
      </div>

      <!-- Fence Status -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Fence Status *</label>
        <div class="space-y-2">
          <label *ngFor="let option of fenceState" class="flex items-center">
            <input 
              type="radio" 
              formControlName="existing" 
              [value]="option.value"
              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
            >
            <span class="ml-2 text-sm text-gray-700">{{ option.label }}</span>
          </label>
        </div>
      </div>
    </div>
  </form>

  <!-- Actions -->
  <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-200">
    <button 
      type="button" 
      [mat-dialog-close]="false"
      class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
    >
      Cancel
    </button>
    <button
      type="button"
      (click)="openDeleteConfirmationDialog()"
      class="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
    >
      Delete
    </button>
    <button
      type="button"
      (click)="updateFenceAndClose()"
      [disabled]="!editFenceForm.valid"
      class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Update
    </button>
  </div>
</div>
